import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-column-filter',
  templateUrl: './column-filter.component.html',
  styleUrls: ['./column-filter.component.scss']
})
export class ColumnFilterComponent implements OnInit {


  @Input() checkboxes: FormGroup;
  @Input() itemsList: any[];
  @Input() gridApi: any;
  @Input() columnApi: any;

  constructor(
  ) { }

  ngOnInit() {
  }

  filterColumns(columnName, value) {
    this.columnApi.setColumnVisible(columnName, value);
    const allColumnIds = [];
    this.columnApi.getAllColumns().forEach(column => {
      allColumnIds.push(column.colId);
    });
    this.gridApi.sizeColumnsToFit();
  }

}
